import { createStore, useStore } from 'zustand';
import { persist } from 'zustand/middleware';
const createOverrideStore = name => createStore()(persist(set => ({
  overrides: {},
  setOverride: (key, value) => set(state => {
    const overrides = Object.assign({}, state.overrides);
    if (value === null) {
      delete overrides[key];
    } else {
      overrides[key] = value;
    }
    return {
      overrides
    };
  }),
  clearAll: () => set({
    overrides: {}
  })
}), {
  name,
  partialize: state => ({
    overrides: state.overrides
  })
}));
export const gateOverridesStore = createOverrideStore('collab-sidebar-gate-overrides');
export const scopeOverridesStore = createOverrideStore('collab-sidebar-scope-overrides');

// Read-only accessors for non-React consumers (auth.ts)
export const gateOverrides = {
  get: key => {
    var _gateOverridesStore$g;
    return (_gateOverridesStore$g = gateOverridesStore.getState().overrides[key]) !== null && _gateOverridesStore$g !== void 0 ? _gateOverridesStore$g : null;
  }
};
export const scopeOverrides = {
  get: key => {
    var _scopeOverridesStore$;
    return (_scopeOverridesStore$ = scopeOverridesStore.getState().overrides[key]) !== null && _scopeOverridesStore$ !== void 0 ? _scopeOverridesStore$ : null;
  }
};
export const useOverrideStore = store => useStore(store);